<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M42.11 11.13a1.5 1.5 0 00-1.22 2.75 22 22 0 11-17.78 0 1.5 1.5 0 00-1.22-2.75 25 25 0 1020.22 0z"/><path d="M32 32a1.5 1.5 0 001.5-1.5v-24a1.5 1.5 0 00-3 0v24A1.5 1.5 0 0032 32z"/></svg>